/* globals console, google, module, require */
/* jshint camelcase:false, esversion:6, globalstrict:true */
'use strict';

let counties;
const async = require('async'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    helpers = require('../utilities/handlebars').helpers,
    configuration = require('./configuration'),
    enumerations = require('./enumerations'),
    //
    crosswalk = {
        administrative_area_level_1: 'state',
        administrative_area_level_2: 'county',
        route: 'street_name',
        locality: 'city'
    },
    shorts = {
        administrative_area_level_1: true,
        country: true
    },
    parsePlace = function (place) {
        const categories = {
                administrative_area_level_1: 'state',
                administrative_area_level_2: 'county',
                locality: 'city',
                postal_code: 'zip',
                route: 'street',
                street_name: 'street',
                street_number: 'streetNumber'
            },
            longNames = {
                locality: true,
                route: true,
                street_name: true
            },
            transformers = {
                county: function (county) {
                    return county.replace(' County', '');
                }
            },
            parsedPlace = {},
            keys = _.keys(place);
        // console.log(place);
        if (keys.length === 1 && keys[0] === 'name') {
            // the user didn't select an item from the suggested list
            return {error: helpers.l10n('programEditAutocompleteAddressNotSelected')};
        }
        _.each(place.address_components, function (component) {
            _.each(component.types, function (type) {
                let category,
                    value,
                    transformer;
                if (type !== 'political') {
                    category = categories[type] || type;
                    value = component[(longNames[type] ? 'long' : 'short') + '_name'];
                    transformer = transformers[category];
                    parsedPlace[category] = transformer ? transformer(value) : value;
                }
            });
        });
        parsedPlace.countyId = parsedPlace.county ? counties[parsedPlace.county.replace(/ /g, '').toLowerCase()] : null;
        parsedPlace.address1 = (parsedPlace.streetNumber ? parsedPlace.streetNumber + ' ' : '') + (parsedPlace.street || '');
        parsedPlace.formattedAddress = place.formatted_address;
        parsedPlace.latitude = _.isFunction(place.geometry.location.lat) ? place.geometry.location.lat() : place.geometry.location.lat;
        parsedPlace.longitude = _.isFunction(place.geometry.location.lng) ? place.geometry.location.lng() : place.geometry.location.lng;
        // console.log(parsedPlace.county, parsedPlace.countyId);
        return parsedPlace;
    },
    EOL = null;

function AddressAutocomplete(input, onLocationChanged) {
    if (!counties) {
        counties = {};
        _.each(enumerations.enumerations.countyId, _.bind(function (county, id) {
            counties[county.code.toLowerCase().substr(6)] = +id;
        }, this));
    }
    if (input) {
        this.autocomplete = new google.maps.places.Autocomplete(input);
        this.autocomplete.setFields(['formatted_address', 'address_components', 'geometry', 'name']);
        this.autocomplete.addListener('place_changed', function () {
            onLocationChanged(parsePlace(this.getPlace()));
        });
    }
}

AddressAutocomplete.prototype.countyId = function (latitude, longitude, callback) {
    const url = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + configuration.googleApiKey + '&latlng=' + latitude + ',' + longitude;
    jQuery.getJSON(url, function (json) {
        let location = {},
            parsedPlace,
            error = null;
        if (json.status === 'OK') {
            parsedPlace = parsePlace(json.results[0]);
            location.city = parsedPlace.city;
            location.county = parsedPlace.county;
            location.countyId = parsedPlace.countyId;
            location.state = parsedPlace.state;
        } else {
            error = 'Unknown location: ' + location;
        }
        callback(error, location);
    });
};

AddressAutocomplete.prototype.resolveLocation = function (location, callback) {
    let url;
    // console.log('@addressAutocomplete.0');
    if (location.length !== 0) {
        async.waterfall([
            function (callback) {
                // console.log('@addressAutocomplete.1');
                // Hmm... if the zip code is not correct for the city and state, the geocode simply drops the zip code
                // E.g., passing "San Francisco, CA 20052" returns content for San Francisco, CA sans a zip code
                // Additionally, sometimes an invalid zip code only returns no results but sometimes it returns completely unrelated results
                // E.g., passing "99999" returns content for 8280 Willow Oaks Corporate Drive, Fairfax, VA, 22031 (yikes!)
                url = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + configuration.googleApiKey + '&address=' + location.replace(/ /g, '+');
                jQuery.getJSON(url, function (json) {
                    if (json.status === 'OK') {
                        callback(null, parsePlace(json.results[0]));
                    } else {
                        callback('Unknown location: ' + location);
                    }
                });
            },
            _.bind(function (location, callback) {
                // console.log('@addressAutocomplete.2');
                if (!location.countyId) {
                    this.countyId(location.latitude, location.longitude, function (error, results) {
                        if (!results.error) {
                            location.countyId = results.countyId;
                            callback(null, location);
                        } else {
                            callback(results.error);
                        }
                    });
                } else {
                    callback(null, location);
                }
            }, this)
        ], function (error, location) {
            // console.log('@addressAutocomplete.3', location);
            callback(error, location);
        });
    } else {
        callback(null);
    }
};

module.exports = AddressAutocomplete;
